var _excluded = ["style", "contentRef", "portalClassName", "className", "closeTimeoutMS"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useState, useEffect, useCallback } from "react";
import ReactModal from "react-modal";
import { useInnerHeight } from "../../private/useInnerHeight";
import { AnimatedModal } from "./styles";

/**
 * Modal allows the user’s attention to be exclusively focused on one task or information via an overlay that sits on top of the content. Typically, they contain dialogs, but may display any content.
 *
 * @see [Modal documentation](https://construct-kit.reainternal.net/components/web/core/modal)
 */
var Modal = _ref => {
  var {
    getAppElement,
    onRequestClose,
    children,
    opened,
    reactModalProps = {},
    className,
    overlayVariant = "primary"
  } = _ref;
  var {
      style: styleOverrides = {},
      contentRef,
      portalClassName,
      className: reactModalClassName,
      closeTimeoutMS = 200
    } = reactModalProps,
    reactModalPropsRest = _objectWithoutPropertiesLoose(reactModalProps, _excluded);
  var [isOpen, setIsOpen] = useState(false);

  // ReactModal.setAppElement() should happen before any modal is opened
  useEffect(() => ReactModal.setAppElement(getAppElement()), [getAppElement]);
  useEffect(() => setIsOpen(opened), [opened]);
  var scrollRef = useCallback(node => {
    contentRef == null || contentRef(node);
    var htmlTag = document.getElementsByTagName("html")[0];
    if (node) {
      htmlTag.classList.add("CK__Modal_overflow-hidden");
    } else {
      htmlTag.classList.remove("CK__Modal_overflow-hidden");
    }
  }, [contentRef]);
  var innerHeight = useInnerHeight();
  var {
    overlay: overlayStyleOverrides = {},
    content: contentStyleOverrides = {}
  } = styleOverrides;
  var ModalComponent = reactModalClassName ? ReactModal : AnimatedModal;
  return /*#__PURE__*/React.createElement(ModalComponent, _extends({
    contentRef: scrollRef,
    onRequestClose: onRequestClose,
    portalClassName: [portalClassName, className].filter(Boolean).join(" ") || undefined,
    className: reactModalClassName,
    isOpen: isOpen,
    style: {
      overlay: _extends({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 500,
        backgroundColor: undefined
      }, overlayStyleOverrides),
      content: _extends({
        border: "none",
        backgroundColor: "unset",
        position: "unset",
        borderRadius: "unset",
        padding: 0,
        overflow: "auto",
        maxHeight: "" + innerHeight
      }, contentStyleOverrides)
    },
    closeTimeoutMS: closeTimeoutMS,
    $overlayVariant: overlayVariant
  }, reactModalPropsRest), children);
};
Modal.displayName = "Modal";
export default Modal;